import { useDispatch, useSelector } from 'react-redux';
import { useEffectOnce } from 'usehooks-ts';

import { useParseParams } from '@hooks/params';
import { findCancerQuoteParamsSchema } from '@apis/CancerQuoteApi';

import { selectCancerQuoteDetailsPage } from './selector';
import { cancerQuoteFind, CancerQuoteFindPayload } from './action';
import { CancerQuoteDetailsPageParams } from './route';

export const useCancerQuoteDetailsPageParams = () =>
  useParseParams<CancerQuoteDetailsPageParams>(findCancerQuoteParamsSchema);

export const useCancerQuoteFind = () => {
  const dispatch = useDispatch();
  const params = useCancerQuoteDetailsPageParams();
  const { cancerQuote } = useSelector(selectCancerQuoteDetailsPage);

  useEffectOnce(() => {
    const payload: CancerQuoteFindPayload = params;
    dispatch(cancerQuoteFind(payload));
  });

  return cancerQuote;
};
